<div class="wrapper">
  <my-actor-avatar
    *ngIf="showChannel()"
    class="channel"
    [actor]="video().channel" actorType="channel"
    [internalHref]="[ '/c', video().byVideoChannel ]"
    [title]="channelLinkTitle"
    size="35"
  ></my-actor-avatar>

  <my-actor-avatar
    *ngIf="showAccount()"
    class="account"
    [class.second-avatar]="showChannel()"
    [actor]="video().account" actorType="account"
    [internalHref]="[ '/a', video().byAccount ]"
    [title]="accountLinkTitle"
    size="35">
  </my-actor-avatar>
</div>
